import { ColumnsType } from 'antd/lib/table'
import { useState } from 'react'

export const useTableColumnsVisibility = <T extends Record<string, unknown>>(
  columns: ColumnsType<T>,
  defaultHiddenColumns?: string[]
) => {
  const [hiddenColumns, setHiddenColumns] = useState(defaultHiddenColumns ?? [])

  const newColumns = columns?.map((item) => ({
    ...item,
    hidden: hiddenColumns.includes(item.key as string)
  }))

  const onVisibilityColumnsChange = (value: string) => {
    if (hiddenColumns.includes(value)) {
      const newHiddenColumns = hiddenColumns.filter(
        (column) => column !== value
      )
      setHiddenColumns(newHiddenColumns)
    } else {
      setHiddenColumns([...hiddenColumns, value])
    }
  }

  return {
    newColumns,
    hiddenColumns,
    onVisibilityColumnsChange
  }
}
